//MAX_PRODUCTS does not restrict anything, just used for the progress bar and number of preview images to show..
function updateBundleUI() {
    let MAX_PRODUCTS = 6;
    const selectedProducts = [];
    const bundleProducts = document.querySelectorAll('[data-rb-item-id]');

    let selectedCount = 0;
    let productTypeCount = 0;

    let selectedProductsContainer = document.getElementById('selected-products-container');
    if (!selectedProductsContainer) {
        selectedProductsContainer = document.createElement('div');
        selectedProductsContainer.id = 'selected-products-container';
        selectedProductsContainer.className = 'splide';
        
        const parentContainer = document.querySelector('.rb-sticky-content');
        parentContainer.prepend(selectedProductsContainer);
    }
    
    // Clear the container
    selectedProductsContainer.innerHTML = '';
    
    // Create the splide__track div
    const splideTrack = document.createElement('div');
    splideTrack.className = 'splide__track';
    
    // Create the splide__list div
    const splideList = document.createElement('div');
    splideList.className = 'splide__list';
    
    // Append the splide__list to splide__track
    splideTrack.appendChild(splideList);
    
    // Append the splide__track to the selectedProductsContainer
    selectedProductsContainer.appendChild(splideTrack);

    // let splideListE = document.querySelector('.splide__list');

    let parentWrapper = document.querySelector('.recharge-bundles-widget');
    if (parentWrapper && parentWrapper.parentElement) {
        let parentDiv = parentWrapper.closest('.page-width');
        if (parentDiv) {
            parentDiv.classList.replace('page-width', 'page-width--full');
        }
    }

    // const progressBar = document.getElementById('byob-progress-bar');
    // const progressBarFill = document.getElementById('byob-progress-bar-fill');
    // const progressText = document.getElementById('byob-progress-text');
    
    let totalQty = 0;
    bundleProducts.forEach((product) => {
        const input = product.querySelector('.rb-input');
        if (!input) return;

        let addCartButton = product.querySelector('.rb-btn-add-cart');
        if (!addCartButton) {
            addCartButton = document.createElement('button');
            addCartButton.className = 'rb-btn rb-btn--small rb-btn-add-cart tflex titems-center tjustify-center ttc';
            addCartButton.textContent = 'Add +';
            addCartButton.style.display = 'none';
            product.appendChild(addCartButton);

            addCartButton.addEventListener('click', () => {
                input.value = 1;
                input.dispatchEvent(new Event('change'));
            });
        }

        const itemImage = product.querySelector('.rb-item-img');
        let colorBg = product.querySelector('.rb-item-top-color');
        if(!colorBg) {
            colorBg = document.createElement('div');
            colorBg.className = 'rb-item-top-color';
            itemImage.prepend(colorBg);
        }

        const rbTitle = product.querySelector('.rb-title');
        let subheader = product.querySelector('.rb-subheader');
        if (!subheader) {
            subheader = document.createElement('div');
            subheader.className = 'rb-subheader';
            subheader.textContent = window.productFieldMap[product.dataset.rbItemId]['subheader'] + (window.productFieldMap[product.dataset.rbItemId]['identifier'] ? ' | ' + window.productFieldMap[product.dataset.rbItemId]['identifier'] : '');

            rbTitle.parentNode.insertBefore(subheader, rbTitle.nextSibling);
        }

        if (rbTitle) {
            if(window.productFieldMap[product.dataset.rbItemId]['short_title'] != '') {
                rbTitle.textContent = window.productFieldMap[product.dataset.rbItemId]['short_title'];
            }
        }

        // let reviews = product.querySelector('.rb-reviews');
        // if (!reviews) {
        //     // Create the new element you want to insert
        //     reviews = document.createElement('div');
        //     reviews.className = 'rb-reviews';
        //     reviews.textContent = window.productFieldMap[product.dataset.rbItemId]['reviews'];

        //     // Insert the new element after the rb-title element
        //     subheader.parentNode.insertBefore(reviews, rbTitle.nextSibling);
        // }

        let reviews = product.querySelector('.rb-reviews');
        if (!reviews) {
            // Create the new element you want to insert
            reviews = document.createElement('div');
            reviews.className = 'rb-reviews';

            // Get the reviews value
            let reviewsValue = window.productFieldMap[product.dataset.rbItemId]['reviews'];

            // Calculate the width percentage based on the reviews value
            let widthPercentage = (reviewsValue / 5.0) * 100;

            // Create the junip-stars-container structure
            reviews.innerHTML = `
                <div class="junip-stars-container">
                    <div class="junip-stars-outline">
                        <div class="junip-product-summary-star junip-star-outline">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Outline Star</title>
                                <use href="#junipOutlineStar"></use>
                            </svg>
                        </div>
                        <div class="junip-product-summary-star junip-star-outline">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Outline Star</title>
                                <use href="#junipOutlineStar"></use>
                            </svg>
                        </div>
                        <div class="junip-product-summary-star junip-star-outline">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Outline Star</title>
                                <use href="#junipOutlineStar"></use>
                            </svg>
                        </div>
                        <div class="junip-product-summary-star junip-star-outline">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Outline Star</title>
                                <use href="#junipOutlineStar"></use>
                            </svg>
                        </div>
                        <div class="junip-product-summary-star junip-star-outline">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Outline Star</title>
                                <use href="#junipOutlineStar"></use>
                            </svg>
                        </div>
                    </div>
                    <div class="junip-stars-filled" style="width: ${widthPercentage}%;">
                        <div class="junip-product-summary-star junip-star-filled">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Filled Star</title>
                                <use href="#junipFilledStar"></use>
                            </svg>
                        </div>
                        <div class="junip-product-summary-star junip-star-filled">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Filled Star</title>
                                <use href="#junipFilledStar"></use>
                            </svg>
                        </div>
                        <div class="junip-product-summary-star junip-star-filled">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Filled Star</title>
                                <use href="#junipFilledStar"></use>
                            </svg>
                        </div>
                        <div class="junip-product-summary-star junip-star-filled">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Filled Star</title>
                                <use href="#junipFilledStar"></use>
                            </svg>
                        </div>
                        <div class="junip-product-summary-star junip-star-filled">
                            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" role="img">
                                <title>Filled Star</title>
                                <use href="#junipFilledStar"></use>
                            </svg>
                        </div>
                    </div>
                </div>
        `;

        // Insert the new element after the rb-title element
        subheader.parentNode.insertBefore(reviews, subheader.nextSibling);
        }

        const quantity = parseInt(input.value);
        totalQty = totalQty + quantity;
        const minusButton = product.querySelector('.rb-btn-qty-minus');
        const plusButton = product.querySelector('.rb-btn-qty-plus');
        const inputActions = product.querySelector('.rb-item-actions');

        if (quantity === 0) {
            addCartButton.style.display = 'block';
            // minusButton.style.display = 'none';
            // plusButton.style.display = 'none';
            inputActions.style.display = 'none';
            // input.style.display = 'none';
        } else {
            addCartButton.style.display = 'none';
            // minusButton.style.display = 'block';
            // plusButton.style.display = 'block';
            // input.style.display = 'block';
            inputActions.style.display = 'block';
        }

        const itemContent = product.querySelector('.rb-item-content');
        const color = window.productFieldMap[product.dataset.rbItemId]['color'];

        const itemColor = product.querySelector('.rb-item-top-color');


        if (quantity > 0) {
            selectedCount += quantity;
            productTypeCount += 1;
            const productElement = document.createElement('div');
            productElement.classList.add('bundle-product', 'splide__slide');

            const imgSrc = product.querySelector('.rb-img img')?.src;
            const title = product.querySelector('.rb-title').textContent;

            colorBg.style.backgroundColor = color;
            itemContent.style.backgroundColor = color;

            productElement.innerHTML = `
                        <div class="bundle-product__filled">
                            <img class="bundle-product-filled__image"src="${imgSrc}" alt="${title}" />
                            <span class="bundle-product-filled__title">${title}</span>
                            <span class="bundle-product-filled__qty">${quantity}</span>
                            <button class="bundle-product-filled__cta remove-product" data-product-id="${product.dataset.rbItemId}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                <g id="Group_2470" data-name="Group 2470" transform="translate(-388 -648)">
                                    <g id="Group_259" data-name="Group 259" transform="translate(388 648)">
                                    <g id="Rectangle_154" data-name="Rectangle 154" fill="none" stroke="#3a5dae" stroke-width="1">
                                        <rect width="16" height="16" rx="8" stroke="none"/>
                                        <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="none"/>
                                    </g>
                                    </g>
                                    <g id="Group_260" data-name="Group 260" transform="translate(396.047 651.333) rotate(45)">
                                    <line id="Line_12" data-name="Line 12" y2="6.667" transform="translate(3.333)" fill="none" stroke="#3a5dae" stroke-linecap="round" stroke-width="2"/>
                                    <line id="Line_13" data-name="Line 13" y2="6.667" transform="translate(6.667 3.333) rotate(90)" fill="none" stroke="#3a5dae" stroke-linecap="round" stroke-width="2"/>
                                    </g>
                                </g>
                                </svg>
                            </button>
                        </div>
                    `;

            splideList.appendChild(productElement);
            selectedProducts.push({ id: product.id, title, quantity });
        } else {
            colorBg.style.backgroundColor = '';
            itemContent.style.backgroundColor = '';
        }
    });

    if (productTypeCount < MAX_PRODUCTS) {
        const remainingSlots = MAX_PRODUCTS - totalQty;
        for (let i = 0; i < remainingSlots; i++) {
            const fillerElement = document.createElement('div');
            fillerElement.classList.add('bundle-product', 'filler-product', 'splide__slide');
            const isLastProduct = i === (remainingSlots - 1);//TODO - HERE IS THE LAST EMPTY PRODUCT FLAG
            fillerElement.innerHTML = `
                <div class="bundle-product__empty ${ isLastProduct ? 'last-bundle-product' : ''}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29.989" height="29.989" viewBox="0 0 29.989 29.989">
                      <g id="Group_2466" data-name="Group 2466" transform="translate(2906.354 -3417.302) rotate(45)">
                        <g id="Group_1064" data-name="Group 1064" transform="translate(5.812 5.812)">
                          <line id="Line_98" data-name="Line 98" x2="18.377" y2="18.377" transform="translate(367.5 4456.5)" fill="none" stroke="#b9dcd2" stroke-width="4"/>
                          <line id="Line_99" data-name="Line 99" x1="18.377" y2="18.377" transform="translate(367.5 4456.5)" fill="none" stroke="#b9dcd2" stroke-width="4"/>
                        </g>
                      </g>
                    </svg>
                    ${isLastProduct ? '<p>Add 6 for an Extra 5%</p>' : ''}
                </div>
            `;
            splideList.appendChild(fillerElement);
        }
    }

    let discountText = document.getElementById('discount-text');
    let countText = document.getElementById('promo-text__count');
    if(totalQty >= MAX_PRODUCTS){
        if(!discountText){
            const discountText = document.createElement('div');
            discountText.id = 'discount-text';
            discountText.innerHTML = '<span>Congrats! You unlocked additional 5% discount!</span>';
            const addtoCartButton = document.querySelector('.rb-sticky-content .thl-copy');
            addtoCartButton.parentNode.insertBefore(discountText, addtoCartButton);
        }
    } else {
        // if(discountText) discountText.remove();
        if(!discountText){
            const discountText = document.createElement('div');
            discountText.id = 'discount-text';
            discountText.innerHTML = '<span id="promo-text__count" class="mobile-count">0 Items Selected</span><span class="promo-text__discount">Add <span class="count-for-discount">6</span> for an Extra 5%</span><span class="promo-text__success">Congrats! You unlocked additional 5% discount!</span>';
            const addtoCartButton = document.querySelector('.rb-sticky-content .rb-btn');
            addtoCartButton.parentNode.insertBefore(discountText, addtoCartButton);
        }
    }

    const discountElement = document.querySelector('.count-for-discount');
    const promoText = document.querySelector('.promo-text__discount');
    const sucessText = document.querySelector('.promo-text__success');
    const stickyBlock = document.querySelector('.rb-sticky-container');
    if (discountElement) {
        // Perform actions on the element
        discountElement.innerHTML = (6 - totalQty);
        
        const promoTextCount = document.getElementById('promo-text__count');
        if (promoTextCount) {
            if (totalQty > 0) {
                promoTextCount.style.display = 'none'; // Hide the element
            } else {
                promoTextCount.style.display = 'block'; // Show the element
            }

            if(totalQty >= MAX_PRODUCTS) {
                sucessText.style.display = 'block';
                promoText.style.display = 'none';
            } else {
                sucessText.style.display = 'none';
                promoText.style.display = 'inline';
            }

            // if(totalQty == 1) {
            //     stickyBlock.classList.add('open');
            // }
        }
    }

    window.splide = new Splide('#selected-products-container', {
        perPage: 6,
        arrows: false,
        pagination: false,
        gap: '20px',
        breakpoints: {
          1128: {
            perPage: 4,
          },
          900: {
            perPage: 3,
          },
        //   640: {
        //     perPage: 3,
        //     type: 'loop',
        //     fixedWidth: '80%',
        //     focus: 'center',
        //   },
        },
    }).mount();

    let btnNext = document.querySelector('#btnNext-byob');
    let btnPrev = document.querySelector('#btnPrev-byob');

    // Function to update button states
    function updateButtonStates() {
        let currentIndex = window.splide.index;
        let totalSlides = window.splide.length;

        // Get the number of slides per page dynamically
        let perPage = window.splide.options.perPage;

        // Calculate if it's the last set of slides
        let maxIndex = totalSlides - perPage;

        btnPrev.disabled = currentIndex === 0;
        btnNext.disabled = currentIndex >= maxIndex;
    }
    
    // Update buttons on mount and move events
    window.splide.on('mounted moved', updateButtonStates);

    // Do not need, keeping for reference
    // const progress = Math.min((selectedCount / MAX_PRODUCTS) * 100, 100);
    // progressBarFill.style.width = `${progress}%`;
    // progressText.textContent = `${selectedCount}/${MAX_PRODUCTS} products selected`;

    // if (selectedCount >= MAX_PRODUCTS) {
    //     progressBar.classList.add('progress-complete');
    // } else {
    //     progressBar.classList.remove('progress-complete');
    // }

    addRemoveButtonListeners();
}

function addQuantityListeners() {
    const quantityInputs = document.querySelectorAll('.rb-input');
    quantityInputs.forEach((input) => {
        input.addEventListener('change', e => {
            updateBundleUI();
        });
    });

    const buttons = document.querySelectorAll('.rb-btn-qty-plus, .rb-btn-qty-minus');
    buttons.forEach((button) => {
        button.addEventListener('click', e => {
            updateBundleUI();
        });
    });
}

function addSplideArrows() {
    const navElement = document.createElement('div');
    navElement.className = 'splide-slide__nav splide-slide__nav--byob';
    navElement.innerHTML = `
        <button id="btnPrev-byob" class="splide-slide-nav splide-slide-nav--prev">
            <svg xmlns="http://www.w3.org/2000/svg" width="11.799" height="21.098" viewBox="0 0 11.799 21.098">
                <path id="Path_183" data-name="Path 183" d="M3545.094,43.611l-8.781,8.781,8.781,8.781" transform="translate(-3535.063 -41.844)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"/>
            </svg>
        </button>
        <button id="btnNext-byob" class="splide-slide-nav splide-slide-nav--next">
            <svg xmlns="http://www.w3.org/2000/svg" width="11.799" height="21.098" viewBox="0 0 11.799 21.098">
                <path id="Path_183" data-name="Path 183" d="M3536.313,43.611l8.781,8.781-8.781,8.781" transform="translate(-3534.545 -41.844)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"/>
            </svg>
        </button>
    `;

    const targetElement = document.querySelector('.rb-sticky-content .tlh-title');
    if (targetElement) {
        targetElement.parentNode.insertBefore(navElement, targetElement.nextSibling);
    }

    let btnNext = document.querySelector('#btnNext-byob');
    let btnPrev = document.querySelector('#btnPrev-byob');
    btnNext.addEventListener('click', (e) => {
        window.splide.go('+1');
    });
    
    btnPrev.addEventListener('click', (e) => {
        window.splide.go('-1');
    });
}

function addMobileNav() {
    const stickyBlock = document.querySelector('.rb-sticky-container');
    
    if (stickyBlock) {
        const newContent = document.createElement('div');
        newContent.className = 'rb-mobile-toggle';
        newContent.innerHTML = `
            <span class="rb-mobile__title">Your Subscription Cart</span>
            <span class="js-rb-mobile-toggle">
                <span class="toggle-hide">Hide</span>
                <span class="toggle-show">Show</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="11.962" height="7.231" viewBox="0 0 11.962 7.231" class="toggle-arrow">
                    <path id="Path_1038" data-name="Path 1038" d="M0,8.426,4.213,4.213,0,0" transform="translate(1.768 5.463) rotate(-90)" fill="none" stroke="#3a5dae" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"/>
                </svg>
            </span>
        `;
    
        stickyBlock.insertBefore(newContent, stickyBlock.firstChild);
    }
    
    const toggleButton = document.querySelector('.rb-mobile-toggle');
    
    // Function to handle class assignment based on screen size
    function updateClasses() {
        const isDesktop = window.matchMedia("(min-width: 900px)").matches;
    
        if (isDesktop) {
            stickyBlock.classList.remove('close');
            stickyBlock.classList.add('desktop'); // Add your desktop class here
        } else {
            stickyBlock.classList.remove('desktop');
            stickyBlock.classList.add('close');
        }
    }
    
    // Initial check and set class based on screen size
    updateClasses();
    
    // Add event listener to handle resize and apply class accordingly
    window.addEventListener('resize', updateClasses);
    
    // Toggle functionality for the mobile toggle button
    toggleButton.addEventListener('click', () => {
        if (stickyBlock) {
            stickyBlock.classList.toggle('open');
        }
    });

        // const toggleHide = toggleButton.querySelector('.toggle-hide');
        // const toggleShow = toggleButton.querySelector('.toggle-show');
    
        // if (toggleButton && stickyBlock) {
        //     toggleButton.addEventListener('click', function() {
        //         // Toggle the 'close' class on the rb-sticky-content element
        //         stickyBlock.classList.toggle('close');
    
        //         // Toggle the 'close' class on the toggle-hide and toggle-show elements
        //         toggleHide.classList.toggle('close');
        //         toggleShow.classList.toggle('close');
        //     });
        // }
}

function addRemoveButtonListeners() {
    const removeButtons = document.querySelectorAll('.remove-product');
    removeButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            const productId = e.currentTarget.dataset.productId;
            const productInput = document.querySelector(`[data-rb-item-id="${productId}"] .rb-input`);
            if (productInput) {
                productInput.value = 0;
                productInput.dispatchEvent(new Event('change'));
            }
        });
    });
}

const ProductFilter = (function() {
    let activeFilters = [];
    const filters = [
        ['Best Sellers', 'best_seller'],
        ['Floss Picks', 'Floss Picks'],
        ['Toothbrushes', 'toothbrushes'],
        ['Travel Kits', 'Travel Kits'],
        ['Tongue Scrapers', 'Tongue Scrapers'],
        ['Floss String', 'Floss String'],
        ['Kids', 'kids'],
    ];
    let productFieldMap = window.productFieldMap;
  
    function init() {
      createFilterBar();
      hideFilterBar();
    }
  
    function createFilterBar() {
        const existingFb = document.querySelector('.filter-bar');
        if (existingFb) {
            return;
        }
    
        // Create the filter-bar-wrapper div
        const filterBarWrapper = document.createElement('div');
        filterBarWrapper.className = 'filter-bar-wrapper';
    
        // Create the filter-bar div
        const filterBar = document.createElement('div');
        filterBar.className = 'filter-bar';
        // Uncomment and adjust styles as needed
        // filterBar.style.cssText = `
        //   background-color: white;
        //   box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        //   padding: 1rem;
        //   z-index: 1000;
        //   display: flex;
        //   align-items: center;
        //   justify-content: flex-start;
        // `;
    
        filters.forEach(([label, tag]) => {
            const button = document.createElement('button');
            button.textContent = label;
            button.dataset.tag = tag;
            button.className = 'filter-button';
            // button.style.cssText = `
            //   margin-right: 0.5rem;
            //   padding: 0.5rem 1rem;
            //   border: none;
            //   border-radius: 9999px;
            //   background-color: #e2e8f0;
            //   color: #1a202c;
            //   cursor: pointer;
            //   transition: background-color 0.3s, color 0.3s;
            // `;
            button.addEventListener('click', () => toggleFilter(tag));
            filterBar.appendChild(button);
        });
    
        // Append the filter-bar to the filter-bar-wrapper
        filterBarWrapper.appendChild(filterBar);
    
        const rechargeBundlesElement = document.querySelector('.rb-filters');
        if (rechargeBundlesElement) {
            rechargeBundlesElement.parentNode.insertBefore(filterBarWrapper, rechargeBundlesElement);
        } else {
            console.warn('Element with id "recharge-bundles" not found. Filter bar not inserted.');
        }
    }
  
    function hideFilterBar() {
      const filterBar = document.querySelector('.rb-filters');
      if(filterBar){
        filterBar.style.display = 'none';
      }
    }
  
    function toggleFilter(tag) {
      const index = activeFilters.indexOf(tag);
      if (index > -1) {
        activeFilters.splice(index, 1);
      } else {
        activeFilters.push(tag);
      }
      updateFilterButtons();
      applyFilters();
    }
  
    function updateFilterButtons() {
      const buttons = document.querySelectorAll('.filter-button');
      buttons.forEach(button => {
        if (activeFilters.includes(button.dataset.tag)) {
            button.classList.add('active');
        //   button.style.backgroundColor = '#3b82f6';
        //   button.style.color = 'white';
        } else {
            button.classList.remove('active');
        //   button.style.backgroundColor = '#e2e8f0';
        //   button.style.color = '#1a202c';
        }
      });
    }
  
    function applyFilters() {
      const products = document.querySelectorAll('[data-rb-item-id]');
      products.forEach(product => {
        const productId = product.getAttribute('data-rb-item-id');
        const productTags = productFieldMap[productId]?.tags || [];
        
        const shouldShow = activeFilters.length === 0 || 
          activeFilters.some(filter => productTags.includes(filter));
        
        product.style.display = shouldShow ? 'flex' : 'none';
      });
    }
  
    return {
      init: init
    };
  })();

  
let listenersAdded = false;
let arrowsAdded = false;
let selectMoved = false;
let mobileNav = false;
const byobObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        const quantityInputs = document.querySelectorAll('.rb-input');
        if (quantityInputs.length === 0) {
            return;
        }

        if (!listenersAdded) {
            listenersAdded = true;
            addQuantityListeners();
        }

        if(!arrowsAdded) {
            arrowsAdded = true;
            addSplideArrows();
        }

        updateBundleUI();
        if(!selectMoved){
            createCustomFrequencySelector();
            selectMoved = true;
        }
        
        if(!mobileNav) {
            mobileNav = true;
            addMobileNav();
        }

        setupObserver();
        ProductFilter.init();
        byobObserver.disconnect();
    });
});

function createCustomFrequencySelector() {
    const originalSelect = document.querySelector('.rb-frequency-wrapper select');

    if (!originalSelect) {
        console.error('Original frequency select not found');
        return;
    }

    const ogSelectWrapper = document.querySelector('.rb-frequency-wrapper');
    ogSelectWrapper.style.display = 'none';

    const customSelect = document.createElement('select');
    customSelect.id = 'custom-selling-plan-list';
    customSelect.className = 'custom-select select__select select__select--box';

    Array.from(originalSelect.options).forEach(opt => {
        const newOpt = document.createElement('option');
        newOpt.value = opt.getAttribute('data-selling-plan-id');
        newOpt.textContent = 'Every '+opt.querySelector('span').textContent;
        customSelect.appendChild(newOpt);
    });

    const wrapper = document.createElement('div');
    wrapper.className = 'custom-frequency-wrapper';
    wrapper.innerHTML = `
        <div class="custom-field custom-frequency">
        </div>
    `;
    wrapper.querySelector('.custom-field').appendChild(customSelect);
    
    const targetElement = document.querySelector('.rb-sticky-content .tlh-title');
    if (targetElement) {
        targetElement.parentNode.insertBefore(wrapper, targetElement.nextSibling);
        targetElement.textContent = 'Choose at least 1 item to subscribe and save!';
    } else {
        console.error('Target element for insertion not found');
        return;
    }

    customSelect.addEventListener('change', function() {
    const selectedOption = this.options[this.selectedIndex];
    const correspondingOption = originalSelect.querySelector(`option[data-selling-plan-id="${selectedOption.value}"]`);

    if (correspondingOption) {
        correspondingOption.selected = true;
        const event = new Event('change', { bubbles: true });
        originalSelect.dispatchEvent(event);
    }
    });

    originalSelect.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        const sellingPlanId = selectedOption.getAttribute('data-selling-plan-id');
        const correspondingOption = customSelect.querySelector(`option[value="${sellingPlanId}"]`);

        if (correspondingOption) {
            correspondingOption.selected = true;
        }
    });
}

//This is an odd work around, but debounce was necessary to not create a loop.
let isMoving = false;
let moveTimeout = null;

function moveThsCopy() {
    if (isMoving) return;
    isMoving = true;

    const thlCopy = document.querySelector('.thl-copy');
    const addToCartButton = document.querySelector('.rb-sticky-content .rb-btn');
    const discountText = document.getElementById('discount-text');

    if (thlCopy && addToCartButton) {
        const container = addToCartButton.parentElement;
        
        if (discountText) {
            if (thlCopy.nextElementSibling !== discountText) {
                container.insertBefore(thlCopy, discountText);
            }
        } else {
            if (thlCopy.nextElementSibling !== addToCartButton) {
                container.insertBefore(thlCopy, addToCartButton);
            }
        }
    }

    isMoving = false;
}

function debouncedMove() {
    clearTimeout(moveTimeout);
    moveTimeout = setTimeout(moveThsCopy, 50);
}

function setupObserver() {
    const targetNode = document.querySelector('.rb-sticky-content');

    if (!targetNode) {
        console.error('Target node for observation not found');
        return;
    }

    const config = { childList: true, subtree: true, characterData: true, attributes: true };

    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList' || 
                mutation.type === 'characterData' || 
                (mutation.type === 'attributes' && mutation.target.classList.contains('thl-copy'))) {
                debouncedMove();
                break;
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

byobObserver.observe(document.body, { childList: true, subtree: true });

